var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCode)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"mask"},[_c('div',{staticClass:"qrcode"},[_c('img',{attrs:{"src":require("@/assets/image/ewm.png")}}),_c('span',[_vm._v("手机扫一扫上方二维码，预约看房")]),_c('img',{staticClass:"close",attrs:{"src":require("../../../../assets/image/gb.png")},on:{"click":_vm.closeCode}})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }